/* Store locator fără Google Maps API — Leaflet + tile-uri OSM/Carto.
   Izolat în IIFE ca să nu interfereze cu bundle-ul temei. */
(function () {
  var TILES = {
    voyager: {
      url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd'
    },
    positron: {
      url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
      subdomains: 'abcd'
    },
    osm: {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      subdomains: 'abc'
    }
  };

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function makeIcon(color) {
    var svg =
      '<svg width="30" height="42" viewBox="0 0 30 42" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 27 15 27s15-16.5 15-27C30 6.7 23.3 0 15 0z" fill="' + color + '"/>' +
      '<circle cx="15" cy="15" r="5.5" fill="#ffffff"/></svg>';
    return L.divIcon({
      className: 'slm-pin',
      html: svg,
      iconSize: [30, 42],
      iconAnchor: [15, 42],
      popupAnchor: [0, -38]
    });
  }

  function initSection(section) {
    var dataEl = section.querySelector('[data-slm-data]');
    var mapEl = section.querySelector('.slm__map');
    if (!dataEl || !mapEl) return;

    var stores;
    try {
      stores = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    stores = (stores || []).filter(function (s) {
      s.lat = parseFloat(s.lat);
      s.lng = parseFloat(s.lng);
      return !isNaN(s.lat) && !isNaN(s.lng);
    });
    if (!stores.length) return;

    var color = (getComputedStyle(section).getPropertyValue('--slm-pin') || '').trim() || '#1a1b18';
    var tileKey = section.getAttribute('data-slm-tiles') || 'voyager';
    var singleZoom = parseInt(section.getAttribute('data-slm-zoom'), 10) || 14;
    var tile = TILES[tileKey] || TILES.voyager;

    var map = L.map(mapEl, { scrollWheelZoom: true, zoomControl: true });
    L.tileLayer(tile.url, {
      attribution: tile.attribution,
      subdomains: tile.subdomains,
      maxZoom: 19
    }).addTo(map);

    var icon = makeIcon(color);
    var markers = {};
    var bounds = [];

    stores.forEach(function (s) {
      var marker = L.marker([s.lat, s.lng], { icon: icon }).addTo(map);
      var html = '<strong>' + escapeHtml(s.title) + '</strong>';
      if (s.address) html += '<br>' + escapeHtml(s.address);
      if (s.url) {
        html += '<br><a href="' + encodeURI(s.url) + '" target="_blank" rel="noopener">' +
          escapeHtml(s.btn || 'Deschide în Maps') + '</a>';
      }
      marker.bindPopup(html);
      marker.on('click', function () { openCard(s.i); });
      markers[s.i] = marker;
      bounds.push([s.lat, s.lng]);
    });

    if (bounds.length === 1) {
      map.setView(bounds[0], singleZoom);
    } else {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 14 });
    }
    setTimeout(function () { map.invalidateSize(); }, 200);
    window.addEventListener('load', function () { map.invalidateSize(); });

    function focusStore(i) {
      var marker = markers[i];
      if (!marker) return;
      map.setView(marker.getLatLng(), Math.max(map.getZoom(), 13), { animate: true });
      marker.openPopup();
    }

    function openCard(i) {
      var card = section.querySelector('[data-slm-index="' + i + '"]');
      if (card) card.open = true;
      focusStore(i);
    }

    section.querySelectorAll('[data-slm-index]').forEach(function (card) {
      var idx = parseInt(card.getAttribute('data-slm-index'), 10);
      var summary = card.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function () {
        // starea `open` se actualizează după acest handler
        setTimeout(function () {
          if (card.open) focusStore(idx);
        }, 0);
      });
    });
  }

  function boot() {
    if (typeof L === 'undefined') {
      return setTimeout(boot, 60);
    }
    document.querySelectorAll('[data-slm]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
